// src/pages/Admin/VotePage/components/VoteAdminHeader.jsx

import React from "react";
import {
  FaChartBar,
  FaUsers,
  FaVoteYea,
} from "react-icons/fa";

export default function VoteAdminHeader() {
  return (
    <header className="relative overflow-hidden bg-gradient-to-br from-indigo-700 via-violet-700 to-fuchsia-700">
      <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
      <div className="absolute -bottom-32 right-0 h-80 w-80 rounded-full bg-fuchsia-300/20 blur-3xl" />

      <div className="relative mx-auto max-w-[1380px] px-4 py-7 text-white sm:px-6 sm:py-9">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex items-start gap-4">
            <div className="hidden h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white/15 text-2xl shadow-xl ring-1 ring-white/20 backdrop-blur sm:flex">
              <FaVoteYea />
            </div>

            <div>
              <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-[11px] font-black uppercase tracking-[0.14em] ring-1 ring-white/20">
                Administration
              </div>

              <h1 className="text-2xl font-black tracking-tight sm:text-3xl">
                Votes et sondages
              </h1>

              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-indigo-100">
                Créez vos consultations, définissez leur audience,
                gérez les questions et analysez la participation.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2 text-xs sm:flex">
            <div className="flex items-center gap-2 rounded-xl bg-white/10 px-3 py-2 ring-1 ring-white/15 backdrop-blur">
              <FaUsers />
              Audiences ciblées
            </div>

            <div className="flex items-center gap-2 rounded-xl bg-white/10 px-3 py-2 ring-1 ring-white/15 backdrop-blur">
              <FaChartBar />
              Résultats détaillés
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}